import React, { Component } from 'react';
import PropTypes from 'prop-types';

import memoize from 'memoize-one';

import UploadMediaModal from '../../components/_molecules/UploadMediaModal/UploadMediaModal';
import MediaLibraryFull from '../../components/_molecules/MediaLibraryFull/MediaLibraryFull';

import './MediaLibraryScreen.scss';
import Button from '../../components/_atomic/Button/Button';
import { LOADING, SUCCESS, publicHash, ERROR } from '../../utils/constants';
import SuccessModal from '../../components/_molecules/SuccessModal/SuccessModal';
import LoadingOverlay from '../../components/_molecules/LoadingOverlay/LoadingOverlay';
import ErrorModal from '../../components/_molecules/ErrorModal/ErrorModal';


class MediaLibraryScreen extends Component {
  static propTypes = {
    match: PropTypes.shape({}).isRequired,
    getAppWithMedia: PropTypes.func.isRequired,
    uploadMedia: PropTypes.func.isRequired,
    uploadMediaStatus: PropTypes.string.isRequired,
    deleteMedia: PropTypes.func.isRequired,
    attachMedia: PropTypes.func.isRequired,
    attachMediaStatus: PropTypes.string.isRequired,
    attachMediaError: PropTypes.string.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    // getAppsWithMedia: PropTypes.func.isRequired,
    getAppMediaStatus: PropTypes.string.isRequired,
    resetAppsWithMedia: PropTypes.func.isRequired,
    appsFullMedias: PropTypes.shape({}).isRequired,
    appsFullMediasStatus: PropTypes.string.isRequired,
    pageAppsFullMedias: PropTypes.string.isRequired,
    hasMoreAppsFullMedias: PropTypes.bool.isRequired,
    apps: PropTypes.shape({}).isRequired,
    hasMoreApps: PropTypes.bool.isRequired,
    getAppsStatus: PropTypes.string.isRequired,
    pageApps: PropTypes.string.isRequired,
    getApps: PropTypes.func.isRequired,
    getAppCampaigns: PropTypes.func.isRequired,
    currentAppCampaigns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getAppsWithMedia: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool,
    resetCampaignStore: PropTypes.func.isRequired,
    sidebarStatus: PropTypes.bool.isRequired,
  };
  static defaultProps = {
    isAdmin: false,
  }
  state = {
    showMediaUploadModal: false,
  };

  componentWillMount() {
    const { getApps } = this.props;

    getApps({ page: 0, projection: 'SHORT' });
    // if (!currentAppFullMedias.length) {
    //   getAppsWithMedia();
    // }
  }

  componentDidMount() {}
  componentDidUpdate(prevProps) {
    const {
      hasMoreApps, pageApps, getApps, getAppsStatus,
    } = this.props;
    if (
      getAppsStatus !== prevProps.getAppsStatus &&
      getAppsStatus === SUCCESS &&
      hasMoreApps
    ) {
      getApps({ page: pageApps + 1, projection: 'SHORT' });
    }
  }
  componentWillUnmount() {
    this.props.resetCampaignStore();
    this.props.resetAppsWithMedia();
  }

  navigateHandler = () => {
    clearInterval(this.mediaUploadInterval);
    this.mediaUploadInterval = undefined;
    this.props.history.push(`${publicHash}/app`);
  };

  toggleMediaUploadModal = (show) => {
    const { uploadMediaStatus } = this.props;
    if (show && uploadMediaStatus !== LOADING) {
      this.setState(() => ({ showMediaUploadModal: show }));
    }
    if (!show) {
      this.setState(() => ({ showMediaUploadModal: show }));
    }
  };
  updateSelectedFiles = (value) => {
    this.setState(() => ({
      selectedFiles: [...value],
    }));
  };
  extractApps = memoize(apps => [
    ...apps.map(app => ({ value: app.id, label: app.name })),
  ]);

  transformCampaigns = memoize(campaigns => [
    ...campaigns.map(campaign => ({
      value: campaign.id,
      label: campaign.name,
    })),
  ]);

  render() {
    const {
      match,
      uploadMedia,
      uploadMediaStatus,
      attachMediaError,
      attachMediaStatus,
      apps,
      getAppCampaigns,
      currentAppCampaigns,
      deleteMedia,
      attachMedia,
      appsFullMedias,
      appsFullMediasStatus,
      getAppsWithMedia,
      pageAppsFullMedias,
      hasMoreAppsFullMedias,
      getAppMediaStatus,
      getAppWithMedia,
      hasMoreApps,
      isAdmin,
      sidebarStatus,
    } = this.props;
    const { showMediaUploadModal } = this.state;
    const currentUpdateApp = match.params.appId;
    const currentCampaign = match.params.campaignId;
    const transformedApps = this.extractApps(apps);
    const transformCampaigns = this.transformCampaigns(currentAppCampaigns);
    const isMediaUploading = uploadMediaStatus === LOADING;
    const buttonLabel = isMediaUploading ? 'Loading...' : 'Upload';
    const isLoading = attachMediaStatus === LOADING || hasMoreApps;
    return (
      <div className="main-library-screen">
        <SuccessModal
          visible={attachMediaStatus === SUCCESS}
          text="Attached files successfully uploaded"
          buttonClick={this.navigateHandler}
        />
        <LoadingOverlay visible={isLoading} />
        <ErrorModal
          visible={attachMediaStatus === ERROR}
          error={attachMediaError}
        />

        <UploadMediaModal
          visible={showMediaUploadModal}
          apps={transformedApps}
          getAppCampaigns={getAppCampaigns}
          currentAppCampaigns={transformCampaigns}
          currentUpdateApp={currentUpdateApp}
          currentUpdateCampaign={currentCampaign}
          uploadMedia={uploadMedia}
          requestClose={() => this.toggleMediaUploadModal(false)}
          uploadMediaStatus={uploadMediaStatus}
          getAppWithMedia={getAppWithMedia}
          isAdmin={isAdmin}
        />
        <Button
          label={buttonLabel}
          clickHandler={() => {
            this.toggleMediaUploadModal(true);
          }}
          secondary
          disabled={isMediaUploading}
          className="upload-media"
        />

        <MediaLibraryFull
          deleteMedia={deleteMedia}
          campaignId={currentCampaign}
          getAppMediaStatus={getAppMediaStatus}
          appId={currentUpdateApp}
          getSelectedFiles={this.updateSelectedFiles}
          attachMedia={attachMedia}
          currentAppCampaigns={transformCampaigns}
          getAppCampaigns={getAppCampaigns}
          apps={transformedApps}
          loadMedia={getAppsWithMedia}
          mediaApps={appsFullMedias}
          mediaAppsStatus={appsFullMediasStatus}
          hasMoreMediaApps={hasMoreAppsFullMedias}
          pageMediaApps={pageAppsFullMedias}
          isAdmin={isAdmin}
          sidebarStatus={sidebarStatus}
        />
      </div>
    );
  }
}

export default MediaLibraryScreen;



// WEBPACK FOOTER //
// ./src/containers/MediaLibraryScreen/MediaLibraryScreen.js